export const COLLECTION_LINK_DISCLAIMER_MESSAGE = "The booking link below leads to an external site."